import styled from "styled-components";

import FallbackImage from "components/global/FallbackImage";

export const SportProfileSecondaryButton = styled.button.attrs({
  className:
    "inline-flex w-full items-center justify-center gap-2 rounded-2xl border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] px-4 py-3 text-sm font-medium text-[var(--brand-ink)] transition hover:border-[var(--brand-highlight)] hover:bg-[rgba(240,191,86,0.08)] sm:w-auto",
})``;

export const SportProfilePrimaryButton = styled.button.attrs({
  className:
    "inline-flex w-full items-center justify-center gap-2 rounded-2xl bg-[var(--brand-accent)] px-4 py-3 text-sm font-medium text-white transition hover:bg-[var(--brand-accent-deep)] sm:w-auto",
})``;

export const SportProfileSectionActionButton = styled.button.attrs({
  className:
    "inline-flex min-h-[40px] items-center justify-center gap-2 rounded-2xl border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] px-4 py-2 text-sm font-medium text-[var(--brand-ink)] transition hover:border-[var(--brand-highlight)] hover:bg-[rgba(240,191,86,0.08)] disabled:cursor-not-allowed disabled:opacity-45",
})``;

export const SportProfileSectionActions = styled.div.attrs({
  className: "flex w-full flex-col gap-3 sm:w-auto sm:flex-row sm:items-center sm:justify-end",
})``;

export const SportProfileGridLayout = styled.div.attrs({
  className: "grid gap-5 md:grid-cols-2 xl:grid-cols-4",
})``;

export const SportProfileGridLayoutSecondary = styled.div.attrs({
  className: "mt-8 grid gap-6 xl:grid-cols-[0.9fr_1.1fr]",
})``;

export const SportProfileContentStack = styled.div.attrs({ className: "space-y-5" })``;

export const SportProfileOverviewThumbnailFrame = styled.div.attrs({
  className: "relative mx-auto w-fit lg:mx-0",
})``;

export const SportProfilePreviewImage = styled(FallbackImage).attrs({
  className: "mx-auto h-32 w-32 max-w-full rounded-[22px] sm:h-44 sm:w-44 sm:rounded-[24px]",
})``;

export const SportProfileOverviewSportBadge = styled.span.attrs({
  className:
    "absolute -bottom-2 -right-2 inline-flex h-11 w-11 items-center justify-center rounded-full border border-[rgba(255,255,255,0.72)] text-white",
})<{ $accent: string; $glow: string }>`
  background: ${({ $accent }) => $accent};
  box-shadow: 0 18px 34px ${({ $glow }) => $glow};
`;

export const SportProfileOverviewLayout = styled.div.attrs({
  className: "flex flex-col gap-5 lg:flex-row lg:items-start",
})``;

export const SportProfileOverviewDetails = styled.div.attrs({
  className: "min-w-0 flex-1 space-y-2",
})``;

export const SportProfileOverviewIdentity = styled.div.attrs({
  className: "pb-1",
})``;

export const SportProfileOverviewSportChip = styled.div.attrs({
  className:
    "inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-xs font-medium tracking-[0.08em] text-[var(--brand-ink)] uppercase",
})<{ $accent: string; $glow: string }>`
  border-color: ${({ $glow }) => $glow};
  background: linear-gradient(135deg, ${({ $glow }) => $glow}, rgba(255, 255, 255, 0.02));

  svg {
    color: ${({ $accent }) => $accent};
  }
`;

export const SportProfileOverviewRow = styled.div.attrs({
  className:
    "flex items-start justify-between gap-4 border-b border-[var(--brand-border)] py-2 last:border-b-0 last:pb-0",
})``;

export const SportProfileOverviewLabelGroup = styled.div.attrs({
  className: "flex items-center gap-2",
})``;

export const SportProfileOverviewItemIcon = styled.span.attrs({
  className:
    "inline-flex h-7 w-7 items-center justify-center rounded-full bg-[rgba(255,255,255,0.04)] text-[var(--brand-highlight)]",
})``;

export const SportProfileOverviewLabel = styled.p.attrs({
  className: "text-xs uppercase tracking-[0.16em] text-[var(--brand-muted)]",
})``;

export const SportProfileOverviewValue = styled.div.attrs({
  className: "max-w-[62%] text-right text-sm font-medium text-[var(--brand-ink)]",
})``;

export const SportProfileGridLayoutTertiary = styled.div.attrs({
  className: "grid gap-4 md:grid-cols-2",
})``;

export const SportProfileSection = styled.div.attrs({ className: "brand-panel-muted" })``;

export const SportProfileEyebrowText = styled.p.attrs({
  className: "text-xs uppercase tracking-[0.2em] text-[var(--brand-muted)]",
})``;

export const SportProfileTitleText = styled.p.attrs({
  className: "mt-2 text-lg font-medium text-[var(--brand-ink)]",
})``;

export const SportProfileSectionSecondary = styled.div.attrs({ className: "mt-3" })``;

export const SportProfileInfoRow = styled.div.attrs({ className: "flex items-center gap-3" })``;

export const SportProfileThumbnailImage = styled(FallbackImage).attrs({
  className: "h-12 w-12 rounded-2xl",
})``;

export const SportProfileLabelText = styled.p.attrs({
  className: "font-medium text-[var(--brand-ink)]",
})``;

export const SportProfileMetaText = styled.p.attrs({
  className: "text-xs text-[var(--brand-muted)]",
})``;

export const SportProfileInlineLinkButton = styled.button.attrs({
  className:
    "truncate text-xs font-medium text-[var(--brand-highlight)] transition hover:text-[var(--brand-ink)]",
})``;

export const SportProfileSectionTertiary = styled.div.attrs({ className: "mt-8" })``;

export const SportProfileAthleteGrid = styled.div.attrs({
  className: "grid gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5",
})``;

export const SportProfileAthleteCard = styled.button.attrs({
  className:
    "flex h-full w-full flex-col rounded-[20px] border border-[var(--brand-border)] bg-[rgba(255,255,255,0.03)] p-3.5 text-left transition hover:-translate-y-0.5 hover:border-[var(--brand-highlight)] hover:bg-[rgba(240,191,86,0.06)] focus:outline-none focus:ring-2 focus:ring-[rgba(240,191,86,0.35)]",
})``;

export const SportProfileAthleteHeader = styled.div.attrs({
  className: "flex items-center gap-3",
})``;

export const SportProfileAthleteIdentity = styled.div.attrs({
  className: "min-w-0 flex-1 space-y-0.5",
})``;

export const SportProfileAthleteAvatar = styled(FallbackImage).attrs({
  className: "h-12 w-12 rounded-2xl border border-[var(--brand-border)]",
})``;

export const SportProfileAthleteMetaGrid = styled.div.attrs({
  className: "mt-3 space-y-2",
})``;

export const SportProfileAthleteMetaCard = styled.div.attrs({
  className: "flex items-start justify-between gap-3 py-1",
})``;

export const SportProfileAthleteMetaLabel = styled.p.attrs({
  className: "text-xs uppercase tracking-[0.16em] text-[var(--brand-muted)]",
})``;

export const SportProfileAthleteMetaValue = styled.p.attrs({
  className: "max-w-[58%] text-right text-xs font-medium text-[var(--brand-ink)]",
})``;

export const SportProfileAthleteFooterRow = styled.div.attrs({
  className: "mt-3 flex items-center justify-between gap-3",
})``;

export const SportProfileAthleteFooterText = styled.p.attrs({
  className: "text-xs font-medium text-[var(--brand-highlight)]",
})``;

export const SportProfileAthleteActionButton = styled.button.attrs({
  className:
    "inline-flex min-h-[30px] items-center justify-center rounded-xl border border-[var(--brand-error-border)]/20 px-2.5 py-1.5 text-xs font-medium text-[var(--brand-error-text)] transition hover:bg-[var(--brand-error-ring)] disabled:cursor-not-allowed disabled:opacity-45",
})``;

export const SportProfileSearchInput = styled.input.attrs({
  className: "brand-input w-full min-w-[220px] sm:w-[280px]",
})``;

export const SportProfilePaginationBar = styled.div.attrs({
  className:
    "mt-5 flex flex-col gap-3 rounded-[20px] border border-[var(--brand-border)] bg-[rgba(255,255,255,0.03)] px-4 py-3 text-[13px] text-[var(--brand-muted)] sm:flex-row sm:items-center sm:justify-between",
})``;

export const SportProfilePaginationText = styled.p.attrs({
  className: "text-[13px] text-[var(--brand-muted)]",
})``;

export const SportProfilePaginationControls = styled.div.attrs({
  className: "flex items-center gap-3 self-end sm:self-auto",
})``;

export const SportProfilePaginationButton = styled.button.attrs({
  className:
    "inline-flex min-h-[40px] items-center justify-center rounded-2xl border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] px-3 py-2 text-sm text-[var(--brand-ink)] transition hover:border-[var(--brand-highlight)] hover:bg-[rgba(240,191,86,0.08)] disabled:cursor-not-allowed disabled:opacity-45",
})``;

export const SportProfilePaginationLabel = styled.span.attrs({
  className: "font-anonymous text-xs uppercase tracking-[0.18em] text-[var(--brand-muted)]",
})``;

export const SportProfileLinkForm = styled.form.attrs({
  className: "space-y-5",
})``;

export const SportProfileLinkFormCopy = styled.div.attrs({
  className: "space-y-2",
})``;

export const SportProfileLinkFormLabel = styled.label.attrs({
  className: "text-xs uppercase tracking-[0.18em] text-[var(--brand-muted)]",
})``;

export const SportProfileLinkFormSelect = styled.select.attrs({
  className: "brand-input",
})``;

export const SportProfileLinkFormInput = styled.input.attrs({
  className: "brand-input",
})``;

export const SportProfileLinkSearchResults = styled.div.attrs({
  className:
    "overflow-hidden rounded-[20px] border border-[var(--brand-border)] bg-[rgba(255,255,255,0.03)]",
})``;

export const SportProfileLinkSearchResultButton = styled.button.attrs({
  className:
    "flex w-full items-center justify-between gap-3 border-b border-[var(--brand-border)] px-4 py-3 text-left transition hover:bg-[rgba(240,191,86,0.06)] last:border-b-0",
})``;

export const SportProfileLinkSearchResultText = styled.div.attrs({
  className: "min-w-0 space-y-1",
})``;

export const SportProfileLinkBrowseToggle = styled.button.attrs({
  className:
    "inline-flex items-center justify-start text-xs font-medium text-[var(--brand-highlight)] transition hover:text-[var(--brand-ink)]",
})``;

export const SportProfileLinkFormActions = styled.div.attrs({
  className: "flex items-center justify-end gap-3 pt-2",
})``;
